<template>
    <button type="button"
        class="ring-focus rounded px-4 py-2 text-xl outline-none transition-colors
            duration-150 hover:bg-gray-50 focus:bg-gray-50
            focus:outline-2
            focus:outline-white">
        <slot />
    </button>
</template>
